// extracted by mini-css-extract-plugin
export default {"image":"Fotos_image__t6Wu9","row":"Fotos_row__EmukK"};